import React from 'react';
import './features.scss';
import Navbar from '../../components/Navbar/navbar';
import { Link } from 'react-router-dom';
import { motion } from "framer-motion"
import Footer2 from '../../components/Footer/footer2';

const Features = () => {
  return (
    <div className="features">
        <Navbar />    
        <section className="features-section">
            <div className="features-container">
                <div className='zero'>
                <h1>Why Users Love the Orter App for Safe Conversations</h1>

                <p>
                In today’s digital age, privacy and security are more important than ever.
                With countless messaging apps available, users are often left wondering which
                ones truly protect their conversations. Enter the Orter app, a platform that
                has quickly gained popularity for its commitment to safe conversations. But
                what makes Orter stand out? Let’s explore the reasons why users love this app
                and how it ensures their conversations remain private and secure.
                </p>

                    <h2>A Focus on Privacy</h2>

                    <p>
                    One of the primary reasons users flock to the Orter app is its strong focus on
                    privacy. In a world where data breaches are common, Orter takes user privacy
                    seriously.
                    </p>

                    <ul>
                    <li>
                        <strong>End-to-End Encryption:</strong> Orter uses end-to-end encryption to
                        ensure that only the sender and receiver can read the messages. This means
                        that even if someone intercepts the data, they cannot decipher it.
                    </li>
                    <li>
                        <strong>No Data Collection:</strong> Unlike many other apps, Orter does not collect user data. 
                        This commitment to minimal data collection reassures users that their conversations are not 
                        being stored or sold.
                    </li>
                    </ul>
                    <p>These features create a sense of trust, allowing users to communicate freely without the fear of prying eyes.</p>   
                </div>
                <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className='first'>
                <h2>User-Friendly Interface</h2>

                <p>
                One of the primary reasons users flock to the Orter app is its strong focus on
                privacy. In a world where data breaches are common, Orter takes user privacy
                seriously.
                </p>

                <ul>
                <li>
                    <strong>Simple Navigation:</strong> The app is designed with the user in mind. 
                    Navigating through the app is straightforward, making it easy for anyone to use, 
                    regardless of their tech-savviness.
                </li>
                <li>
                    <strong>Customizable Features:</strong> Users can personalize their experience with 
                    various themes and notification settings. This level of customization makes the app 
                    feel more personal and tailored to individual preferences.
                </li>
                </ul>
                <p>A user-friendly interface encourages more people to adopt the app, knowing they can easily navigate its features.</p>
                </motion.div>

                <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className='second'>
                <h2>Secure Group Chats</h2>

                <p>
                Orter also excels in providing secure group chat options. Users can create private groups where all conversations are encrypted.
                </p>

                <ul>
                <li>
                    <strong>Private Groups:</strong> Users can create private groups where only invited members can join. 
                    This feature is perfect for families,friends, or colleagues who want to discuss sensitive topics 
                    without worrying about outsiders.
                </li>
                <li>
                    <strong>Admin Controls:</strong> Group admins have the ability to manage members and control who can send messages. 
                    This ensures that conversations remain focused and relevant.
                </li>
                </ul>
                <p>These group chat features make Orter a popular choice for users who want to maintain privacy in larger conversations.</p>
                </motion.div>
                <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className='third'>
                <h2>Multi-Platform Availability</h2>

                <p>
                In our fast-paced world, users often switch between devices. Orter understands this need and offers multi-platform availability. Users can access their messages and settings seamlessly across all their devices.
                </p>

                <ul>
                <li>
                    <strong>Cross-Device Syncing:</strong> Users can access their conversations on multiple devices, including smartphones, tablets, and computers. 
                    This flexibility allows users to stay connected no matter where they are.
                </li>
                <li>
                    <strong>Seamless Experience:</strong> The app provides a seamless experience across devices, ensuring that users can pick 
                    up right where they left off.
                </li>
                </ul>
                <p>This multi-platform support is a significant advantage for users who value convenience and accessibility.</p>
            </motion.div>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className='fourth'>
                <h2>Enhanced Security Features</h2>

                <p>
                Beyond basic privacy measures, Orter offers enhanced security features that users find appealing. These features provide an extra layer of protection for sensitive conversations.
                </p>

                <ul>
                <li>
                    <strong>Self-Destructing Messages:</strong> Users can send messages that automatically delete after a set time. 
                    This feature is perfect for sharing sensitive information without leaving a trace.
                </li>
                <li>
                    <strong>Two-Factor Authentication:</strong> To further protect accounts, Orter offers two-factor authentication. 
                    This adds an extra layer of security, ensuring that only authorized users can access their accounts.
                </li>
                </ul>
                <p>These enhanced security features provide users with peace of mind, knowing their conversations are protected.</p>
                </motion.div>

                <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className='fifth'>
                <h2>Conclusion: A Safe Haven for Conversations</h2>

                <p>In a world where privacy is often compromised, the Orter app stands out as a safe haven for conversations. With its focus on privacy, user-friendly interface,
                     secure group chats, multi-platform availability, regular updates, strong community support, 
                     and enhanced security features, it is no wonder users love this app. </p>
                
                <p>As more people become aware of the importance of secure communication, Orter is poised to continue its growth and popularity. 
                    For anyone looking for a reliable messaging app that prioritizes safety, Orter is undoubtedly worth considering. </p>
                </motion.div>   
            </div>
        </section>
        <section>
            <div className="features-image-container">
                <motion.div 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="features-text">
                    <p>
                        Download the Orter app today and experience the difference of safe conversations.
                    </p>
                    <Link to="/coming-soon" className="features-download-button">Download the App</Link>
                </motion.div>

                <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="features-image">
                    <img
                    src="https://res.cloudinary.com/dsnontai6/image/upload/v1760378640/Screenshot_2025-09-27_at_18.19.46_bmcj4h.png"
                    alt="Orter Logo"
                    className="features-logo"
                    />
                </motion.div>
                </div>
        </section>
        <Footer2 />
    </div>
  );
};

export default Features;